/*

THIS IS THE COMPONENT THAT WILL BE USED TO RENDER THE APP HEADER

*/


import React, { useState, useEffect } from 'react';
import './CustomerInfoHeader.css';
import Button from '@material-ui/core/Button';
import { useSelector, useDispatch, shallowEqual } from 'react-redux';
import CustomTextField from '../ShippingAddress/CustomTextField';
import { EMAIL } from '../../../constants/RegexConstants';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { makeStyles } from '@material-ui/core/styles';
import CartService from '../../../services/CartService';
import { useTranslation } from 'react-i18next';
import { updateCustomer } from '../../../actions/actionCreators';
import useMediaQuery from '@material-ui/core/useMediaQuery';


const useStyles = makeStyles(theme => ({
  root: {
    "& .MuiFormControlLabel-label": {
      fontFamily: "AvertaRegular, Helvetica, Arial, sansSerif",
      fontSize: "15px"
    },
  },

  LoginBtn: {
    fontSize: "0.7em",
    display: "flex",
    alignSelf: "flex-start",
    textTransform: 'none'
  },
}));

const width90 = { width: '90%' };

const CustomerInfoHeader = () => {

  const classes = useStyles();
  const dispatch = useDispatch();

  const matches = useMediaQuery("(max-width:599px)");

  const customer = useSelector(state => state.cartReducer.customer);
  const navAttempts = useSelector(state => state.navigationReducer.attempts);
  const token = useSelector(state => state.cartReducer.token);
  const frontConfig = useSelector(state => state.frontConfigReducer);
  const mainColor = frontConfig.color;
  const logoutStyle = { fontSize: '0.7em', display: 'flex', alignSelf: 'flex-start', marginTop: '5px', color: mainColor, textTransform: 'none' }

  const [email, setEmail] = useState(customer.email);
  const [emailValid, setEmailValid] = useState(true);
  const [subscribe, setSubscribe] = useState(false);
  const [displayName, setDisplayName] = useState('');

  const { t, i18n } = useTranslation();

  useEffect(() => {
    if (customer.first_name === null || customer.last_name === null) {
      setDisplayName(customer.email);
    } else if (customer.first_name !== null && customer.last_name !== null) {
      setDisplayName(`${customer.first_name} ${customer.last_name}`)
    }
  }, [])

  return (
    <div className="CustomerInfoHeader">
      {/* <p className="CustomerInfoHeaderText">{t("Customer Information")}</p> */}
      {
        customer !== null && customer.is_registered === true ? renderLoggedCustomer() : renderGuestUser()
      }
    </div>
  )

  function renderLoggedCustomer() {
    return (
      <div className="CustomerBasicInfo">
        <div className="AvatarContainer">
          <img className="AvatarImg" src={require('../../../imageAssets/user-profile.svg')} alt="avatar" />
        </div>
        <div className="NameOptionsContainer">
          <p className="CustomerNameEmail">{displayName}</p>
          <p className="CustomerEmailTxt">{`${customer.email}`}</p>
        </div>
        <div>
          <Button onClick={tryLogout} style={logoutStyle}>{`${t("Logout")}`}</Button>
        </div>
      </div>
    )
  }

  function renderGuestUser() {
    return (
      <div className="SignupContainer">
        <CustomTextField
          fieldId={"email"}
          label="Email"
          defaultValue={email}
          onEditCallBack={editEmail}
          onKeyPress={handleKeyPress}
          helperText="Field is required"
          onBlur={handleBlur}
          // metaError={!emailValid}
          containerStyle={width90}
          navAttempts={navAttempts}
        />
        <div className="LoginSignupBtns">
          <Button onClick={tryLogin} className={classes.LoginBtn} variant={matches ? "outlined" : "contained"} color={"primary"}>Login</Button>
        </div>
      </div>
    )
  }

  function toggleSubscribe(e) {
    setSubscribe(e.target.checked);
    let payload = [{ fieldToUpdate: 'accepts_marketing', value: e.target.checked }];
    dispatch(updateCustomer(payload));
  }

  function tryLogout() {
    let url = `${frontConfig.link_store_home}account/logout`;
    window.open(url, "_blank");
  }

  async function tryLogin() {
    let url = `${frontConfig.link_store_home}account/login`;
    window.open(url, "_blank");
    // window.open(url, "_blank");
  }

  function editEmail(value) {
    setEmail(value);
    let payload = [{ fieldToUpdate: 'email', value: value }];
    dispatch(updateCustomer(payload));
  }

  function handleBlur(e) {

  }

  function handleKeyPress(e) {
   
  }
}

export default CustomerInfoHeader;
